import { render, staticRenderFns } from "./editgateway.vue?vue&type=template&id=276e6962&scoped=true"
import script from "./editgateway.vue?vue&type=script&lang=js"
export * from "./editgateway.vue?vue&type=script&lang=js"
import style0 from "./editgateway.vue?vue&type=style&index=0&id=276e6962&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276e6962",
  null
  
)

export default component.exports